import Home from "./pages/Home";
import RoutesNavigation from "./routes/Routes";
function App() {
  return (
    <RoutesNavigation />
  );
}

export default App;
